import Label from "components/Label/Label";
import React from "react";
import { FC } from "react";

export interface FormItemProps {
  className?: string;
  ClassLabel?: string;
  label?: string;
  desc?: string;
}

const FormItem: FC<FormItemProps> = ({
  children,
  className = "",
  ClassLabel = "",
  label,
  desc,
}) => {
  return (
    <div className={className}>
      {label && <Label className={ClassLabel}>{label}</Label>}
      {desc && (
        <span className="block mb-3 text-xs text-neutral-500 dark:text-neutral-400 ">
          {desc}
        </span>
      )}
      <div className="mt-1 w-full">{children}</div>
    </div>
  );
};

export default FormItem;
